export default function() {
    return <nav aria-label="Weitere Datev-Links" id="linkTile">
        <ul>
            <li>
                <a href="https://www.datev.de/hilfe" title="DATEV Hilfe-Center" target="_blank">
                    <span className="icon help" aria-hidden="true"></span>
                    <p>DATEV Hilfe-Center</p>
                </a>
            </li>
            <li>
                <a href="https://www.datev.de/hilfe/0908003" title="Kontakt zu DATEV" target="_blank">
                    <span className="icon contact" aria-hidden="true"></span>
                    <p>Kontakt zu DATEV</p>
                </a>
            </li>
            <li>
                <a href="https://www.datev-community.de/" title="DATEV-Community" target="_blank">
                    <span className="icon community" aria-hidden="true"></span>
                    <p>DATEV-Community</p>
                </a>
            </li>
            <li>
                <a href="https://apps.datev.de/myupdates/product-change/current" title="DATEV MyUpdates" target="_blank">
                    <span className="icon myupdates" aria-hidden="true"></span>
                    <p>DATEV MyUpdates</p>
                </a>
            </li>
        </ul>
    </nav>
}